import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import congrats from '../../assets/onboarding/congrats.gif';
import { safeReturnPath } from '../../auth/returnPath';
import './ThankYouStep.scss';

// No refresh here: OnboardingWizard reloads the context before navigating, once the
// department actually exists. The refresh this page used to do only re-read the user
// and never the hospitals or permitted apps, so it never fixed anything anyway.
const ThankYouStep = () => {
  const { user, authMethod, refreshAllUserData } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  // An Entra user lands here straight from the wizard while the context refresh is
  // still in flight (or failed). Entering the app with the in-progress snapshot would
  // send them back to onboarding, so catch up first.
  // The page the user was going to before signing in (EntraOnboardingWizard), else /welcome.
  const destination = safeReturnPath(location.state?.returnTo) || '/welcome';
  const needsRefresh = authMethod === 'entra'
    && !['completed', 'pending_approval'].includes(user?.entraOnboarding?.status);
  const enterApp = async (event) => {
    if (!needsRefresh) return;
    event.preventDefault();
    await refreshAllUserData();
    navigate(destination);
  };
  const outcome = location.state?.outcome || user?.entraOnboarding?.lastOutcome;
  const title = outcome === 'invitation'
    ? 'ההרשמה הושלמה והשיוך למחלקה כבר מוכן'
    : outcome === 'super_admin'
      ? 'ההרשמה הושלמה. יש לך הרשאות מנהל על'
    : outcome === 'department_created'
      ? 'ההרשמה הושלמה והמחלקה החדשה מוכנה'
    : outcome === 'join_requested'
      ? 'ההרשמה הושלמה. בקשת ההצטרפות נשלחה למנהלי המחלקה'
      : 'מעולה! אנחנו מוכנים. מה איתך?';

  return (
    <div className="thank-you-step">
      <img src={congrats} alt="Thank You" className="thank-you-image" />
      <h2>{title}</h2>
      <Link to={destination} className="onboarding-button" onClick={enterApp}>לאפליקציה</Link>
    </div>
  );
};

export default ThankYouStep;